import {ref, onBeforeMount, computed} from "vue";
import {format} from 'date-fns';
import prayerService from "@/services/prayerService.js"



export function usePrayerList(wallId){
    const prayerList = ref([]);

    onBeforeMount(() =>{
        prayerService.getPrayers(wallId).then(newPrayers => {
            prayerList.value = sortPrayers(newPrayers);
        });
    });

    const structuredPrayerList = computed(() =>{
        const sortedPrayers = prayerList;
        return structurePrayers(sortedPrayers.value);
    })

    return {prayerList, structuredPrayerList};
}

export function useAdminPrayerList(wallId, jwtToken){
    const prayerList = ref([]);

    onBeforeMount(() =>{
        prayerService.getAdminPrayers(wallId, jwtToken).then(newPrayers => {
            prayerList.value = sortPrayers(newPrayers);
        });
    });

    const structuredPrayerList = computed(() =>{
        const sortedPrayers = prayerList;
        return structurePrayers(sortedPrayers.value);
    })

    return {prayerList, structuredPrayerList};
}

function sortPrayers(prayers){
    return prayers.sort((a,b)=>{
        return b.time-a.time;
    });
}

function structurePrayers(prayerList){
    //Let's map it out
    let mappedList = new Map();
    prayerList.forEach(prayer => {

        let prayerDate = new Date(Number(prayer.time));
        let legibleDate = format(prayerDate, "MMM dd");
        if(mappedList.get(legibleDate) === undefined){
            mappedList.set(legibleDate, []);
        }

        mappedList.get(legibleDate).push(prayer);

    });


    //We want it to be structured by day and ordered
    /*[ { day: Aug 10, prayers: [{prayer1}, {prayer2}, {prayer3}]}, {day: Aug 11, prayers: [{Prayer 4}, {Prayer 5}]}]*/

    let structuredPrayerList = [];

    for (const  [key, value] of mappedList){
        structuredPrayerList.push({day: key, prayers: value});
    }
    
    return structuredPrayerList;
}